<template>
    <div class="service_requests_main admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="top_filters_area">
        <div class="filters_area">
            <div style="display: flex; flex-direction: row;">
            <div class="types_selector">
                <b-dropdown :text="filterType" no-caret>
                    <b-dropdown-item v-on:click="onTypeChosen(item)" v-for="(item, index) in types" :key="index">
                        <div class="type_dropdown_item">
                            <div class="name">{{ item }}</div>
                        </div>
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="places_selector">
                <b-dropdown :text="filterPlace.name" no-caret>
                    <b-dropdown-item v-on:click="onPlaceChosen(item)" v-for="(item, index) in places" :key="index">
                        <div class="type_dropdown_item">
                            <div class="name">{{ item.name }}{{item.id ? ' #' + item.id : ''}}</div>
                        </div>
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            </div>
            <div style="display: flex; flex-direction: row;">
            <div class="votes_search">
                <b-form-input
                    v-model="search"
                    placeholder="Start typing to search"
                    class="search_profiles"
                ></b-form-input>
            </div>
            <span style="margin-left: 10px; margin-top: 4px; text-decoration: underline; cursor: pointer;"
                  @click="onRefreshClick">Refresh</span>
            </div>
        </div>
        </div>
        <b-list-group class="votes_list" @scroll="onListScrolled">
            <b-list-group-item v-for="(item, index) in items" :key="index" class="votes_item">
                <div class="control-panel">
                    <div @click="onDeleteRequestClick(item)" class="control-panel-item">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                </div>

                <div class="votes_top" @click="item.showDetails = !item.showDetails">
                    <div class="votes_body">
                        <div class="wrapper"><h5>#{{ item.id }} <b>{{ item.type }}</b></h5>
                        </div>
                        <h5>{{ item.place.name }} |
                            {{ item.question ? (item.question.text + ' (' + item.question.id + ')') : '' }}</h5>
                        <span><a :href="getQuestionManageLink(item)" target="_blank"><span
                            v-if="item.question && item.question.asset_id != ''">{{ item.question ? item.question.asset_id : '' }} | </span>{{ item.question ? item.question.placement : '' }}</a><a
                            v-if="item.gps" :href="getGeolocationGoogleMapLink(item)"
                            target="_blank"> ({{ item.gps.lat }}, {{ item.gps.lng }})</a></span>
                        <p>
                            <i>{{ item.date_created | moment("HH:mm:ss D.MM.YYYY ") }}</i>
                        </p>
                    </div>
                </div>
                <div class="votes_bottom">
                    <div class="votes_place">
                        <span class="votes_comment" v-if="item.notes"><b>Notes:</b> {{ item.notes }}</span>
                        <span class="votes_comment" v-if="item.name || item.phone"><b>Contact info:</b> {{ item.name }} | {{ item.phone }}</span>
                        <div v-if="item.data" class="item-data-details">
                            <span class="votes_comment" v-for="(dataItem) in item.data" v-if="dataItem.value && (dataItem.changed == null || dataItem.changed == true)">
                                <b>{{ dataItem.report_tag }}:</b> {{ dataItem.value }}
                            </span>
                        </div>
                        <div v-if="item.attachments.audio">
                            <audio controls :src="item.attachments.audio.audio_url" class="vote-audio"></audio>
                        </div>
                        <div class="attachments" v-if="item.attachments.images.length > 0">
                            <div v-for="(image, index) in item.attachments.images"
                                 :key="index" style="position: relative">
                                <img :src="image.previewUrl"
                                     @click="onImageClick(image)"/>
                                <div class="delete_cross" @click="deleteImageClick(item, image)">
                                    <img src="@/assets/icons/ic_trash.svg" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-list-group-item>

            <infinite-loading :identifier="infinityValue" @infinite="getServiceRequests">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import customModalDialog from '@/components/widgets/customModalDialog';
import errorMixin from "@/mixins/errorMixin";
import adminStickyHeaderMixin from "@/mixins/adminStickyHeaderMixin";
import adminPageMixin from "@/mixins/adminPageMixin";

export default {
    mixins: [mixin, errorMixin, adminStickyHeaderMixin, adminPageMixin,],
    name: "serviceRequests",
    components: {
        InfiniteLoading,
        customModalDialog
    },
    data() {
        return {
            search: '',
            filterType: 'All types',
            filterTypeDefault: 'All types',
            types: [],
            filterPlace: {name: 'All places', id: 0},
            places: [],
            customModalSettings: {},
            items: [],
            infinityValue: +new Date(),
            page: 1,
            searchTimer: null,
        }
    },
    props: ['infinity'],
    watch: {
        search(value) {
            this.refreshItems()
        },
        infinity(val) {
            this.page = 1
            this.infinityValue += 1
        },
    },
    async mounted() {
        this.initAdminPage()
        this.getServiceRequestsAdminData()
    },
    methods: {
        ...mapActions({
            fetchServiceRequests: 'serviceRequest/fetchServiceRequests',
            deleteServiceRequest: 'serviceRequest/deleteServiceRequest',
            deleteServiceRequestImage: 'serviceRequest/deleteServiceRequestImage',
            fetchServiceRequestsAdminData: 'serviceRequest/fetchServiceRequestsAdminData',
        }),
        resetList() {
            this.page = 1;
            this.votesLoaded = false
            this.items = [];
            this.infinityValue += 1;
        },
        onRefreshClick() {
            this.resetList()
        },
        async getServiceRequestsAdminData() {
            try {
                const response = await this.fetchServiceRequestsAdminData()
                if (response.success) {
                    this.places = response.places
                    this.places.unshift({name: 'All places', id: 0})

                    this.types = response.types
                    this.types.unshift('All types')
                } else {
                    this.showErrorModal()
                }
            } catch (e) {
                this.showErrorModal()
            } finally {
            }
        },
        async getServiceRequests(stateInf) {
            try {
                this.loadingAction = true
                const response = await this.fetchServiceRequests({
                    page: this.page,
                    s: encodeURIComponent(this.search),
                    type: this.filterType == this.filterTypeDefault ? '' : this.filterType,
                    place_id: this.filterPlace.id == 0 ? '' : this.filterPlace.id
                })
                if (response.success) {
                    this.page += 1;
                    if (this.items.length == 0) {
                        for (let i = 0; response.items.length > i; i++) {
                            response.items[i].showDetails = false
                        }
                        this.items = response.items;
                    } else {
                        response.items.forEach((item) => {
                            item.showDetails = false
                            this.items.push(item);
                            console.log(item)
                        })
                    }
                    if (stateInf && stateInf.loaded != undefined) {
                        if (response.items.length === 10) {
                            stateInf.loaded();
                        } else {
                            stateInf.complete();
                        }
                    }
                } else {
                    this.showErrorModal()
                }
            } catch (e) {
                this.showErrorModal()
            } finally {
                this.loadingAction = false
            }
        },

        onDeleteRequestClick(item) {
            this.customModalSettings = {
                message: this.translate('admin_deleteVote', [item.question ? item.question.text : '']),
                onOkHandler: this.deleteRequestAction.bind(null, item),
                showCancelButton: true,
                okButtonText: this.translate('yes'),
                cancelButtonText: this.translate('no'),
            }
        },

        async deleteRequestAction(item) {
            try {
                await this.deleteServiceRequest(item)
                const index = this.items.findIndex(item => item === item)
                this.items.splice(index, 1)

                this.customModalSettings = {
                    message: 'Service request removed',
                    okButtonText: this.translate('yes'),
                    icon: 'ic_allow.svg'
                }
            } catch (error) {
                this.showErrorModal(error.data.error.message)
            }
        },
        deleteImageClick(item, image) {
            this.customModalSettings = {
                message: this.translate('admin_delete_image'),
                onOkHandler: this.deleteImageAction.bind(null, image.uid, item),
                showCancelButton: true,
                okButtonText: this.translate('yes'),
                cancelButtonText: this.translate('no'),
            }
        },
        async deleteImageAction(imageGuid, item) {
            const body = {
                service_request_guid: item.uid,
                image_guid: imageGuid
            }
            try {
                await this.deleteServiceRequestImage(body)
                const index = item.attachments.images.findIndex(element => element.uid == imageGuid)
                item.attachments.images.splice(index, 1)
                this.customModalSettings = {
                    message: this.translate('admin_successImageDelete'),
                    okButtonText: this.translate('yes'),
                    icon: 'ic_allow.svg'
                }
            } catch (error) {
                this.showErrorModal(error.data.error.message)
            }
        },
        refreshItems() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                this.page = 1;
                this.items = [];
                this.infinityValue += 1;
            }, 450);
        },
        onImageClick(item) {
            window.open(item.originUrl, '_blank')
        },
        getGeolocationGoogleMapLink(item) {
            return `https://www.google.com/maps/place/${item.gps.lat},${item.gps.lng}/@${item.gps.lat},${item.gps.lng},17z`
        },
        getQuestionManageLink(item) {
            return `${location.origin}/questions/${item.question ? item.question.uid : ''}/manage`
        },
        onTypeChosen(item) {
            this.filterType = item
            this.refreshItems()
        },
        onPlaceChosen(item) {
            this.filterPlace = item
            this.refreshItems()
        },
        onListScrolled(element) {
            this.fixStickyHeader(element.srcElement.scrollTop)
        },
    }
}
</script>
<style>
.service_requests_main .dropdown-item {
    padding-left: 0;
    padding-right: 0;
}
.service_requests_main .dropdown .dropdown-menu.show {
    display: flex;
    flex-direction: column;
}
</style>
<style scoped>
.votes_list {
    max-height: calc(100vh - 62px);
}
.btn-group, .btn-group-vertical {
    width: 100% !important;
}

.service_requests_main .dropdown /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-weight: 700;
    position: relative;
    padding: 5px 50px 5px 0;
    margin-left: 0;
    font-size: 16px;
    font-family: 'Nunito';
    overflow: hidden;
}

.service_requests_main .dropdown:before {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    content: " ";
    background: #3F405C;
    width: 100%;
    height: 1px;
}

.service_requests_main .dropdown:after {
    content: '';
    height: 7px;
    width: 7px;
    transform: rotate(45deg);
    right: 10px;
    top: 10px;
    position: absolute;
    border-bottom: 2px solid black;
    border-right: 2px solid black;
}

.filters_area {
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    margin-bottom: 4px;
}
.types_selector {
    max-width: 200px;
    margin-right: 12px;
    width: 100px;
    margin-top: 4px;
}
.places_selector {
    max-width: 200px;
    margin-right: 12px;
    width: 200px;
    margin-top: 4px;
}
.type_dropdown_item {
    display: flex;
    flex-direction: column;
    white-space: pre-wrap;
    max-width: 100%;
}
.type_dropdown_item .name {
    font-size: 16px;
}

.votes_list {
    overflow: auto;
    margin-bottom: 0;
    width: 100%;
    min-width: 100%;
}

.votes_item {
    display: table;
    width: 100%;
    min-width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    font-size: .75em

}

.votes_top {
    display: flex;
    width: 100%;
    padding: .5em 1em 0;
}

.votes_bottom {
    width: 100%;
    flex-direction: row;
    display: flex;
    padding: 0 1em;
}

.votes_comment {
    font-weight: 500;
}

.item-data-details {

}

.attachments {
    height: 170px;
    overflow: scroll;
    display: flex;
}

.attachments img {
    max-width: 100%;
    max-height: 170px;
    cursor: pointer;
}

.delete_cross img {
    margin-top: 5px;
    position: absolute;
    top: 0;
    left: 90px;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);;
    border-radius: 6px;
}

.votes_bottom > div {
    width: 100%;
    padding-top: .25em;
    padding-bottom: .25em;
}

.votes_bottom h5 {
    font-weight: 700;
    font-size: 1em;
    margin-bottom: .2em;
}

.votes_bottom span {
    display: block;
}

.votes_bottom .votes_place {
    padding-right: 1em;
    position: relative;
}

.votes_bottom .votes_place:before {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.075);
}

.votes_bottom .votes_customer {
    padding-left: 1em;
}

.votes_img img {
    width: 3.5em;
    height: 3.5em;
    transform: scale(1);
    margin: 0;
}

.gps_icon {
    width: auto;
    height: 17px;
}

.votes_body {
    display: flex;
    flex-direction: column;
    width: calc(100% - 5em);
}

.votes_body h5 {
    font-weight: 700;
    font-size: 1em;
    margin-bottom: .2em;
}

.votes_body p {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
}

.votes_body a {
    color: black;
    cursor: pointer;
    text-decoration: underline;
}

.vote-audio {
    margin-top: 8px;
    height: 25px;
    width: 100%;
    max-width: 400px;
    display: block;
}

.wrapper {
    display: flex;
}

@media screen and (max-width: 600px) {
    .filters_area {
        flex-direction: column;
    }
}
</style>
